export const INIT_CHECKOUT = 'checkout/INIT_CHECKOUT';
export const CHECKOUT_REQUEST = 'checkout/CHECKOUT_REQUEST';
export const CHECKOUT_SUCCESS = 'checkout/CHECKOUT_SUCCESS';
export const CHECKOUT_ERROR = 'checkout/CHECKOUT_ERROR';
export const VALIDATE_ADDRESS_FLOW = 'checkout/VALIDATE_ADDRESS_FLOW';
export const VALIDATE_ADDRESS_REQUEST = 'checkout/VALIDATE_ADDRESS_REQUEST';
export const VALIDATE_ADDRESS_SUCCESS = 'checkout/VALIDATE_ADDRESS_SUCCESS';
export const VALIDATE_ADDRESS_ERROR = 'checkout/VALIDATE_ADDRESS_ERROR';
export const VALIDATE_ADDRESS_PICK_FROM_SUGGESTED =
  'checkout/VALIDATE_ADDRESS_PICK_FROM_SUGGESTED';
export const VALIDATE_ADDRESS_CONFIRM = 'checkout/VALIDATE_ADDRESS_CONFIRM';
export const VALIDATE_ADDRESS_CANCEL = 'checkout/VALIDATE_ADDRESS_CANCEL';
export const VALIDATE_ADDRESS_EDIT = 'checkout/VALIDATE_ADDRESS_EDIT';
export const FETCH_SHIPPING_RATES_REQUEST =
  'checkout/FETCH_SHIPPING_RATES_REQUEST';
export const FETCH_SHIPPING_RATES_SUCCESS =
  'checkout/FETCH_SHIPPING_RATES_SUCCESS';
export const FETCH_SHIPPING_RATES_ERROR = 'checkout/FETCH_SHIPPING_RATES_ERROR';
export const EDIT_SECTION = 'checkout/EDIT_SECTION';
export const CLOSE_SECTION = 'checkout/CLOSE_SECTION';
export const CONFIRM_CHECKOUT_DATA = 'checkout/CONFIRM_CHECKOUT_DATA';
